import request from '../utils/request'
import request2 from '../utils/request_2'

/*
    供货商商品管理列表
*/
export function productList(data) {
    return request({
        url: '/product/productList',
        method: 'POST',
        data,
    })
}

/*
    供货商订单管理列表
*/
/*
export function orderList(data) {
    return request({
        url: '/order/orderList',
        method: 'POST',
        data,
    })
}
*/

/*
    供应商添加商品
*/
export function addProduct(data) {
    return request({
        url: '/commodity/addProduct',
        method: 'POST',
        data,
        loading: true,
        loadingText: '正在提交中...'
    })
}

/*
    供应商商品列表
*/
export function mallItemList(data) {
    return request({
        url: '/commodity/mallItemList',
        method: 'POST',
        data,
    })
}

/*
    供应商商品上下架及删除功能
*/
export function updateItemState(data) {
    return request({
        url: '/commodity/updateItemState',
        method: 'POST',
        data,
    })
}

/*
    供应商商品详情
*/
export function getMallItemInfo(data) {
    return request({
        url: '/commodity/getMallItemInfo',
        method: 'POST',
        data,
        loading: true
    })
}

/*
    供应商编辑商品
*/
export function editMallItemInfo(data) {
    return request({
        url: '/commodity/editMallItemInfo',
        method: 'POST',
        data,
        loading: true,
        loadingText: '正在提交中...'
    })
}

/*
    供应商库存列表
*/
export function getStockList(data) {
    return request({
        url: '/commodity/getStockList',
        method: 'POST',
        data,
    })
}

/*
   供应商修改库存
*/
export function editStock(data) {
    return request({
        url: '/commodity/editStock',
        method: 'POST',
        data,
        loading: true,
        loadingText: '正在提交...'
    })
}

/*
    供应商添加商品获取品牌
*/
export function brandListByUser(data) {
    return request({
        url: '/commodity/brandListByUser',
        method: 'POST',
        data,
    })
}

/*
    供应商个人设置添加品牌
*/
export function addBrand(data) {
    return request({
        url: '/commodity/addBrand',
        method: 'POST',
        data,
    })
}

/*
    供应商订单列表
*/
export function orderList(data) {
    return request({
        url: '/dwOrder/orderList',
        method: 'POST',
        data,
    })
}

/*
    供应商销售商订单详情
*/
export function getReserverOrderInfo(data) {
    return request({
        url: '/dwOrder/getOrderPurchaseInfo',
        method: 'POST',
        data,
        loading: true
    })
}

/*
    供应商销售商锁仓单详情
*/
export function getOrderReserveInfo(data) {
    return request({
        url: '/dwOrder/getOrderReserveInfo',
        method: 'POST',
        data,
        loading: true
    })
}

/*
    订单状态更新
*/
export function updateReserverOrderState(data) {
    return request({
        url: '/dwOrder/updateReserverOrderState',
        method: 'POST',
        data,
        loading: true,
        loadingText: '正在提交...'
    })
}


/*
    下载商品表格
*/
export function exportItemInfo(data) {
    return request({
        url: '/export/exportItemInfo',
        method: 'POST',
        data,
        timeout: 0,
        loading: true,
        loadingText: '正在生成下载链接...'
    })
}

/*
    下载商品表格 (Updated on 2020.7.27  by chao) 供应商
*/
export function exportMallList(data) {
    return request2({
        url: '/?s=item&op=export',
        method: 'POST',
        data,
        timeout: 0,
        loading: true,
        loadingText: '正在生成下载链接...'
    })
}
/*
    下载库存表格 (Updated on 2020.7.30  by chao) 供应商
*/
export function exportStockList(data) {
    return request2({
        url: '/?s=stock&op=export',
        method: 'POST',
        data,
        timeout: 0,
        loading: true,
        loadingText: '正在生成下载链接...'
    })
}

/*
    上传库存表格 (Updated on 2020.8.5  by chao) 供应商
*/
export const uploadStockFileApi = process.env.VUE_APP_BASE_API_2 + '/?s=stock&op=import'


/*
    根据下单订单号参数获取核销订单列表
*/
export function getOrderEstablish(data) {
    return request({
        url: '/dwOrder/getOrderEstablish',
        method: 'POST',
        data
    })
}

/*
    清算详情
*/
export function liquidateInfo(data) {
    return request({
        url: '/dwOrder/liquidateInfo',
        method: 'POST',
        data,
        loading: true
    })
}


/*
    获取各类型账单列表
*/
export function getBillList(data) {
    return request({
        url: '/dwOrder/getBillList',
        method: 'POST',
        data,
    })
}

/*
    确认平台结款
*/
export function confirmTransferPayment(data) {
    return request({
        url: '/dwOrder/confirmTransferPayment',
        method: 'POST',
        data,
        loading: true
    })
}

/*
    发起清算操作
*/
export function launchLiquidate(data) {
    return request({
        url: '/dwOrder/launchLiquidate',
        method: 'POST',
        data,
        loading: true
    })
}

/*
    获取退货数量信息
*/
export function returnGoodInfo(data) {
    return request({
        url: '/dwOrder/returnGoodInfo',
        method: 'POST',
        data,
    })
}

/*
    确认退货数量
*/
export function confirmRefundQuantity(data) {
    return request({
        url: '/dwOrder/confirmRefundQuantity',
        method: 'POST',
        data,
    })
}


/*
    清算-确认销售商结款
*/
export function confirmLiquidatePayment(data) {
    return request({
        url: '/dwOrder/confirmLiquidatePayment',
        method: 'POST',
        data,
    })
}



/*
    获取锁仓列表
*/
export function reserverOrderList(data) {
    return request({
        url: '/dwOrder/reserverOrderList',
        method: 'POST',
        data,
    })
}

/*
    获取下单列表
*/
export function getPurchaseList(data) {
    return request({
        url: '/dwOrder/getPurchaseList',
        method: 'POST',
        data,
    })
}

/*
    清算获取符合要求的下单列表
*/
export function getOrderPurchaseList(data) {
    return request({
        url: '/dwOrder/getOrderPurchaseList',
        method: 'POST',
        data,
    })
}


/*
    获取清算列表
*/
export function getLiquidateList(data) {
    return request({
        url: '/dwOrder/getLiquidateList',
        method: 'POST',
        data,
    })
}

/*
    清算前，检查有没有付款没有确认的
*/
export function checkPaymentStatus(data) {
    return request({
        url: '/dwOrder/checkPaymentStatus',
        method: 'POST',
        data,
        loading: true
    })
}

/*
    检查款号有没有重复
*/
export function checkStyleNumber(data) {
    return request({
        url: '/commodity/checkStyleNumber',
        method: 'POST',
        data,
    })
}

/*
    供应商首页数据
*/
export function getIndexDataInfo(data) {
    return request({
        url: '/dwOrder/getIndexDataInfo',
        method: 'POST',
        data,
    })
}

/*
    运营供应商选择商品
    (int userId,Set<Integer> itemIds)
*/
export function addShelvesNewMall(data) {
    return request({
        url: '/commodity/shelvesNewMall',
        method: 'POST',
        data,
    })
}































